import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Slider from '@material-ui/core/Slider'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import InfoButton from '../../InfoButton'
import { makeStyles } from '@material-ui/styles'

import { setUnitsToRecallAction } from '../../../redux/reducers/criteria/actions'

const useStyles = makeStyles({
  slider: {
    '& .MuiSlider-valueLabel': {
      fontSize: '10px',
    },
  },
});
 
const max = 20000
const label = max / 10
const marks = [];
for (let i = 0; i <= max; i += label) {
  let label;
  if (i % 1000 === 0 && i !== 0) {
    label = `${i / 1000}k`;
  } else if (i % 1000 === 500) {
    label = `${i / 1000}k`;
  } else {
    label = `${i}`;
  }
  marks.push({ value: i, label: label });
}

const UnitsToRecall = () => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const unitsToRecall = useSelector(state => state.criteria.unitsToRecall)
  const [localValue, setLocalValue] = useState(unitsToRecall)

  return (
    <>
      <Box display="flex">
        <Typography id="units-to-recall">
          Units to recall
          <InfoButton
            tooltipContent={
              <>
                <Typography variant="h6" gutterBottom>
                  Units to recall
                </Typography>
                <Typography variant="body2" gutterBottom>
                  How many stock units should be recalled.
                </Typography>
                <Typography variant="caption">
                  Note: Depending on the filters and other parameters, there may
                  not be enough eligible stock units for this value to be
                  reached.
                </Typography>
              </>
            }
          />
        </Typography>
      </Box>
      <Slider
        aria-labelledby="units-to-recall"
        className={classes.slider}
        value={localValue}
        getAriaValueText={v => v.toString()}
        marks={marks}
        max={max}
        min={0}
        onChange={(_, value) => setLocalValue(value)}
        onChangeCommitted={() => dispatch(setUnitsToRecallAction(localValue))}
        onDragEnd={(a, b) => console.log(a, b)}
        step={100}
        valueLabelDisplay="auto"
      />
    </>
  )
}

export default UnitsToRecall
